export const SET_HRMS12X_COLUMNS = 'SET_HRMS12X_COLUMNS'
export const GET_HRMS12X_COLUMNS = 'GET_HRMS12X_COLUMNS'
export const SET_HRMS12X_LABELS = 'SET_HRMS12X_LABELS'
export const GET_HRMS12X_LABELS = 'GET_HRMS12X_LABELS'
export const RECEIVED_HRMS12X_COLUMNS_LABELS = 'RECEIVED_HRMS12X_COLUMNS_LABELS'
export const SET_HRMS12X_INDEX = 'SET_HRMS12X_INDEX'
export const GET_HRMS12X_INDEX = 'GET_HRMS12X_INDEX'
export const RECEIVED_HRMS12X_INDEX = 'RECEIVED_HRMS12X_INDEX'
export const POST_HRMS12X_SENDMAIL = 'POST_HRMS12X_SENDMAIL'
export const RECEIVED_HRMS12X_LISTFIELDS = 'RECEIVED_HRMS12X_LISTFIELDS'
export const SET_HRMS12X_LISTFIELDS = 'SET_HRMS12X_LISTFIELDS'
export const GET_HRMS12X_LISTFIELDS = 'GET_HRMS12X_LISTFIELDS'
export const SET_HRMS12X_ADD_EMPEMAIL = 'SET_HRMS12X_ADD_EMPEMAIL'
export const GET_HRMS12X_EMPEMAIL = 'GET_HRMS12X_EMPEMAIL'
export const RECEIVED_HRMS12X_DETAIL = 'RECEIVED_HRMS12X_DETAIL'
export const SET_HRMS12X_DETAIL = 'SET_HRMS12X_DETAIL'
export const GET_HRMS12X_DETAIL = 'GET_HRMS12X_DETAIL'
export const GET_HRMS12X_SENDMAILDISP = 'GET_HRMS12X_SENDMAILDISP'
export const GET_HRMS12X_NOTSENDDISP = 'GET_HRMS12X_NOTSENDDISP'
export const GET_HRMS12X_DETAILNOTSEND = 'GET_HRMS12X_DETAILNOTSEND'
export const SET_HRMS12X_DETAILNOTSEND = 'SET_HRMS12X_DETAILNOTSEND'



// WEBPACK FOOTER //
// ./src/store/modules/hrms12x/mutation-types.js